import * as enums from "../enums/enums";

export const tagFilter = (state = null, action) => {
  switch (action.type) {
    case enums.SET_TAG_FILTER:
      return action.tag;

    default:
      return state;
  }
};

export const topicFilter = (state = null, action) => {
  switch (action.type) {
    case enums.SET_TOPIC_FILTER:
      return action.topic;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tagFilter.js